// STORE DEPENDANCY
import { Action } from '@ngrx/store';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';

export enum ActionTypes {
  // MASTER BUSINESS ACTIONS
  MASTER_BUSINESS_COMMON = '[Master Business] Business Common',
  MASTER_BUSINESS_COMMON_SUCCESS = '[Master Business] Business Common Success',
}

// -------------------------------
//  Master Business Common
// -------------------------------
export class MasterBusinessCommonAction implements Action {
  readonly type = ActionTypes.MASTER_BUSINESS_COMMON;
  constructor(public payload: ApiPayload) { }
}

// -------------------------------
//  Master Business Common Success
// -------------------------------
export class MasterBusinessCommonSuccessAction implements Action {
  readonly type = ActionTypes.MASTER_BUSINESS_COMMON_SUCCESS;
  constructor(public response?: any) { }
}

export type Actions =
  | MasterBusinessCommonAction
  | MasterBusinessCommonSuccessAction;
